import React from 'react';
import { Typography, Box, Grid } from '@mui/material';
import {
  AccessTime, AttachMoney, FlashOn,
  PhoneIphone, Security, Translate,
} from '@mui/icons-material';

const cardData = [
  {
    icon: <AccessTime fontSize="large" sx={{ color: '#00BFFF' }} />,
    title: 'Real-Time Tracking',
    description: 'Always know when your link is clicked and a booking is made — no guessing.',
  },
  {
    icon: <AttachMoney fontSize="large" sx={{ color: '#00BFFF' }} />,
    title: 'Earn 10% Per Booking',
    description: 'Flat, simple, and generous. No complicated percentages or minimum thresholds.',
  },
  {
    icon: <FlashOn fontSize="large" sx={{ color: '#00BFFF' }} />,
    title: 'Fast Payouts',
    description: 'Get paid quickly through PayPal, e-transfer, or local options — no long wait times.',
  },
  {
    icon: <PhoneIphone fontSize="large" sx={{ color: '#00BFFF' }} />,
    title: 'Mobile-Friendly Dashboard',
    description: 'Track clicks, bookings, and earnings from your phone, anywhere, anytime.',
  },
  {
    icon: <Security fontSize="large" sx={{ color: '#00BFFF' }} />,
    title: 'Secure & Transparent',
    description: 'No hidden fees. You’ll always see what you’ve earned and when to expect payment.',
  },
  {
    icon: <Translate fontSize="large" sx={{ color: '#00BFFF' }} />,
    title: 'Multilingual Support',
    description: 'English & Spanish support for affiliates and travelers. Built for the Dominican Republic — backed by Canadian trust.',
  },
];

const WhyJoinCanam = () => (
  <Box width="100%" bgcolor="#F4F4F4" py={8} px={{ xs: 2, sm: 4, md: 8, lg: 15 }}>
    <Box textAlign="center" mb={6}>
      <Typography
        variant="h4"
        fontWeight={900}
        fontFamily="Lato"
        fontSize={{ xs: '1.5rem', md: '2rem' }}
      >
        Why Join the CanAm Affiliate Program?
      </Typography>
      <Typography
        maxWidth="800px"
        mx="auto"
        fontFamily="Lato"
        fontSize={{ xs: '14px', md: '16px' }}
        color="#000000"
        mt={2}
        textAlign="center"
      >
        Designed for locals, drivers, agents, and anyone who knows a tourist — our program makes it easy to earn. Here&apos;s what makes us stand out:
      </Typography>
    </Box>

    <Grid container spacing={4} justifyContent="center">
      {cardData.map((card, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Box textAlign="center" px={{ xs: 1, md: 2 }}>
            <Box mb={2}>{card.icon}</Box>
            <Typography
              variant="h6"
              fontWeight={700}
              fontFamily="Lato"
              gutterBottom
              fontSize={{ xs: '1rem', md: '1.1rem' }}
            >
              {card.title}
            </Typography>
            <Typography
              fontFamily="Lato"
              fontSize="14px"
              color="#000000CC"
            >
              {card.description}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default WhyJoinCanam;
